import { TextToSubscribeDescriptionElement } from "@redotech/redo-model/content-builder/element-schema";
import { memo } from "react";
import { Text } from "../../text";
import { FormElementProps } from "./index";

export const TextToSubscribeDescription = memo(
  function TextToSubscribeDescription({
    element,
  }: FormElementProps<TextToSubscribeDescriptionElement>) {
    const displayText = element.text;

    return <Text>{displayText}</Text>;
  },
);
